export default function Maintenance() {
  return (
    <div className="h-screen flex flex-col items-center justify-center bg-black text-white text-center px-6">
      <h1 className="text-4xl font-bold mb-4">🚧 Under Maintenance</h1>
      <p className="text-gray-400 max-w-md">
        We are currently performing scheduled maintenance.
        Please check back in a few minutes.
      </p>
    </div>
  );
}